"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmsAutoActivationUnconditional = void 0;
const country_1 = require("../enums/country");
const isSmsAutoActivationUnconditional = (country) => {
    return country === country_1.OrganizationCountry.Canada;
};
exports.isSmsAutoActivationUnconditional = isSmsAutoActivationUnconditional;
